import {
  UI_BRAND_TYPE_ALL,
  UI_BRAND_TYPE_DAY,
  UI_BRAND_TYPE_FEATURED,
  UI_BRAND_TYPE_MONTH,
  UI_BRAND_TYPE_WEEK,
  UI_PRODUCT_TYPE_CATEGORY,
  UI_PRODUCT_TYPE_FEATURED,
  UI_PRODUCT_TYPE_FRESH,
  UI_PRODUCT_TYPE_HOT,
  UI_PRODUCT_TYPE_SALE, UI_QL_TYPE_BLOOD_GLUCOSE, UI_QL_TYPE_BLOOD_REQUEST,
  UI_QL_TYPE_CALL_CUSTOMER_CARE, UI_QL_TYPE_CALL_PHARMACIST, UI_QL_TYPE_UPLOAD_PRESCRIPTION,
  UI_STATIC_REFER_OTHERS,
  UI_STATIC_TYPE_BANNER,
  UI_STATIC_TYPE_BLOOD_REQ,
  UI_STATIC_TYPE_CAMPAIGN, UI_STATIC_TYPE_MOBILE_FOOTER,
  UI_STATIC_TYPE_NAMASTE_DOC,
  UI_STATIC_TYPE_NOTICE,
  UI_STATIC_TYPE_P_EVENTS,
  UI_STATIC_TYPE_REFERRAL,
  UI_TYPE_BRAND,
  UI_TYPE_FOCUSED, UI_TYPE_GROUP, UI_TYPE_NORMAL,
  UI_TYPE_PRODUCT,
  UI_TYPE_QL,
  UI_TYPE_STATIC
} from "../constants";
import FocusedItems from "../elements/focused";
import React from "react";
import BrandWeek from "../elements/brand/BrandWeek";
import BrandMonth from "../elements/brand/BrandMonth";
import AllBrands from "../elements/brand/AllBrands";
import BrandDay from "../elements/brand/BrandDay";
import NamasteDoctorBanner from "../elements/NamasteDoctorBanner";
import NoticeBanner from "../elements/NoticeBanner";
import AppReferralBanner from "../elements/AppReferralBanner";
import OnGoingCampaigns from "../elements/campaigns";
import PromotionalEvents from "../elements/campaigns/PromotionalEvents";
import ProductSpecials from "../elements/products/ProductSpecials";
import FlashSaleList from "../elements/products/FlashSaleList";
import QuickLinksBanner, {
  BloodGlucoseBanner,
  BloodRequestBanner,
  CustomerCareBanner, PhonePharmacistBanner, UploadPrescriptionBanner
} from "../elements/quick_links/QuickLinksBanner";
import {DynamicUiGroup} from "../elements/DynamicUiGroup";
import MobileFooter from "../elements/MobileFooter";
import {getUiBreadCrumbFormat} from "../dynamicUiFunctions";
import DynamicCarousel from "../elements/carousel/DynamicCarousel";
import { ReferralBanner } from "../elements/ReferralBanner";
import ProductFeatured from "../elements/products/ProductFeatured";
import Prediction from "../elements/prediction/Prediction";

const getDynamicItemFor = (section, {...props} = {}) => {
  if (section.type === UI_TYPE_PRODUCT) {
    if (section.sub_type === UI_PRODUCT_TYPE_CATEGORY)
      return <div {...props}>Not Implemented</div>;
    else if (section.sub_type === UI_PRODUCT_TYPE_HOT)
      return <ProductSpecials {...props}/>;
    else if (section.sub_type === UI_PRODUCT_TYPE_FRESH)
      return <ProductSpecials isHot={false} {...props}/>;
    else if (section.sub_type === UI_PRODUCT_TYPE_FEATURED)
      return <ProductFeatured {...props}/>;
    else if (section.sub_type === UI_PRODUCT_TYPE_SALE)
      return <FlashSaleList {...props}/>;
  } else if (section.type === UI_TYPE_FOCUSED) {
    return <FocusedItems section={section} {...props}/>;
  } else if (section.type === UI_TYPE_STATIC) {
    if (section.sub_type === UI_STATIC_REFER_OTHERS)
      return <ReferralBanner showArrowButton={true} {...props}/>
    else if (section.sub_type === UI_STATIC_TYPE_NOTICE)
      return <NoticeBanner {...props}/>;
    else if (section.sub_type === UI_STATIC_TYPE_NAMASTE_DOC)
      return <NamasteDoctorBanner {...props}/>;
    else if (section.sub_type === UI_STATIC_TYPE_REFERRAL)
      return <AppReferralBanner {...props}/>;
    else if (section.sub_type === UI_STATIC_TYPE_CAMPAIGN)
      return <OnGoingCampaigns {...props}/>;
    else if (section.sub_type === UI_STATIC_TYPE_P_EVENTS)
      return <PromotionalEvents {...props}/>;
    else if (section.sub_type === UI_STATIC_TYPE_BLOOD_REQ)
      return <BloodRequestBanner {...props}/>;
    else if (section.sub_type === UI_STATIC_TYPE_MOBILE_FOOTER)
      return <MobileFooter {...props}/>;
  } else if (section.type === UI_TYPE_BRAND) {
    if (section.sub_type === UI_BRAND_TYPE_DAY)
      return <BrandDay section={section} {...props}/>;
    else if (section.sub_type === UI_BRAND_TYPE_MONTH)
      return <BrandMonth section={section} {...props}/>;
    else if (section.sub_type === UI_BRAND_TYPE_WEEK)
      return <BrandWeek {...props}/>;
    else if (section.sub_type === UI_BRAND_TYPE_ALL || section.sub_type === UI_BRAND_TYPE_FEATURED)
      return <AllBrands featured={section.sub_type === UI_BRAND_TYPE_FEATURED} {...props}/>;
  } else if (section.type === UI_TYPE_QL) {
    if (section.sub_type === UI_QL_TYPE_CALL_CUSTOMER_CARE)
      return <CustomerCareBanner {...props}/>;
    else if (section.sub_type === UI_QL_TYPE_CALL_PHARMACIST)
      return <PhonePharmacistBanner {...props}/>;
    else if (section.sub_type === UI_QL_TYPE_UPLOAD_PRESCRIPTION)
      return <UploadPrescriptionBanner {...props}/>;
    else if (section.sub_type === UI_QL_TYPE_BLOOD_REQUEST)
      return <BloodRequestBanner {...props}/>;
    else if (section.sub_type === UI_QL_TYPE_BLOOD_GLUCOSE)
      return <BloodGlucoseBanner {...props}/>;
  } else if (section.type === UI_TYPE_GROUP) {
    return <DynamicUiGroup section={section} {...props}/>;
  } else if(section.type === UI_TYPE_NORMAL) {
    if (section.sub_type === UI_STATIC_TYPE_BANNER)
      return <DynamicCarousel {...props} section={section}/>;
    else 
      return <Prediction {...props} section={section}/>

  }

  return <div className="mt-4" key={props.key}>( Not Implemented <span
    className="font-bold text-primary-500">{getUiBreadCrumbFormat(section)}</span> )</div>;
};

export default getDynamicItemFor;
